import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ToastController, ViewController } from 'ionic-angular';
import { Comentarios, ItemTip } from '../../app/interfaces';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { EditarComentarioComponent } from '../editar-comentario/editar-comentario';

/**
 * Generated class for the PopoverComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'popover',
  templateUrl: 'popover.html'
})
export class PopoverComponent {
  
  comentario: Comentarios;
  itemTip: ItemTip;
  
  constructor(public viewCtrl: ViewController,
              public popoverCtrl: PopoverController,
              public navCtrl: NavController,
              public toastCtrl: ToastController,
              private restApi: RestApiProvider,
              public navParams: NavParams) 
    {
    this.comentario = this.navParams.get('comentarios');
    if (!this.comentario) {
      return;
    }
    this.itemTip = this.navParams.get('itemTip');
    if (!this.itemTip) {
      this.itemTip = {title: '', id: 0};
      this.navCtrl.setRoot('TabTipsPage');
    }
  }

  editarComentario(myEvent, comentario: Comentarios, itemTip: ItemTip) {
    let popover = this.popoverCtrl.create(EditarComentarioComponent, 
      {comentario, itemTip}, { cssClass: 'custom-popover'});
    popover.present({
      // ev: myEvent
    });
  }

  borrarComentario(comentario) {
    this.restApi.borrarComentario(comentario)
    .subscribe((response: any) => { 
        const toast = this.toastCtrl.create({
          message: 'Comentario eliminado',
          duration: 2000
        });
        toast.present();
    });
    this.cerrarpop();
  }

  cerrarpop() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/components/popover/popover.ts